import React from 'react';
import classNames from 'classnames';
import bowser from 'yola-bowser';
import { DIRECTION } from './constants';
const ModalButtonGroup = ({ direction = DIRECTION.left, children }) => {
  const [firstChild, secondChild, thirdChild] = React.Children.toArray(children);
  const isMobile = bowser.mobile;

  const classes = classNames('ws-ui-modal-button-group', `ws-ui-modal-button-group--${direction}`, {
    'ws-ui-modal-button-group--mobile': isMobile,
  });

  return (
    <div className={classes}>
      <div className="ws-ui-modal-button-group__wrapper">
        {firstChild}
        {secondChild}
      </div>
      {thirdChild}
    </div>
  );
};

export default ModalButtonGroup;
